<template>
  <div>
    <v-form @submit.prevent="sendResetPasswordEmail">
      <EmailInput
        v-model="email"
        label='登録済みのメールアドレス'
      />
      <SendResetPasswordEmailButton
        label='再設定メールを送信する'
        @sendResetPasswordEmail="sendResetPasswordEmail"
      />
    </v-form>
  </div>
</template>
<script>
import EmailInput from '/src/components/uiParts/inputFields/EmailInput'
import SendResetPasswordEmailButton from '/src/components/pages/ResetPassword/SendResetPasswordEmailButton'
import api from '@/plugins/api'

export default {
  name: 'ResetPasswordContainer',
  components: {
    EmailInput,
    SendResetPasswordEmailButton
  },
  data () {
    return {
      email: ''
    }
  },
  methods: {
    async sendResetPasswordEmail () {
      this.$store.dispatch('LoaderStore/displayLoader')
      try {
        await api.sendResetPasswordEmail({ email: this.email })
        const payload = {
          status: 200,
          message: 'メールを送信しました。'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
        this.$router.push('/user_auths/sign_in')
      } catch (error) {
        this.$store.dispatch('LoaderStore/hideLoader')
        const payload = {
          status: error.response.status,
          message: error.response.data.message
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      } finally {
        this.$store.dispatch('LoaderStore/hideLoader')
      }
    }
  }
}
</script>
